import { format } from 'date-fns';
import { LineChartProps } from '@components/report/chart/line-chart/LineChart';

import { VerticalBarAverageChartProps } from '@components/report/chart/vertical-bar-average-chart/VerticalBarAverageChart';

import { NBReportRes } from '@apis/orval/model';

import round from '@utils/round';

import { VisitorsAndViewsProps } from './VisitorsAndViews';

export class VisitorsAdapter {
	value: NBReportRes;
	constructor(obj: NBReportRes) {
		this.value = obj;
	}

	get visitorList() {
		return (
			(this.value?.visitor_statistics?.avg_daily_visitor_list?.value_list ?? []).map(
				(v) => Number(v) ?? 0,
			) ?? []
		);
	}
	get dateList() {
		return (
			(this.value?.visitor_statistics?.avg_daily_visitor_list?.date_list ?? []).map(
				(v) => v ?? '',
			) ?? []
		);
	}
	get difference() {
		return this.visitorList[0] - this.visitorList[this.visitorList.length - 1];
	}

	get isPositive() {
		return this.difference < 0 ? 'high' : this.difference > 0 ? 'low' : 'normal';
	}

	get totalVisitors() {
		const totalVisitorNum = this.value.visitor_statistics?.total_visitor ?? undefined;

		if (!totalVisitorNum) return '-';
		return round(totalVisitorNum, 'down');
	}
	get avgVisitors() {
		const avgVisitorsNum = this.value.visitor_statistics?.avg_daily_visitor ?? undefined;

		if (!avgVisitorsNum) return '-';
		return round(avgVisitorsNum, 'down');
	}

	adapt(): LineChartProps {
		return {
			desc: (
				<>
					누적 방문자는 <span>{this.totalVisitors} 명</span>입니다.
					<br />
					평균 일방문자는 <span>{this.avgVisitors} 명</span>입니다.
				</>
			),
			datas_a: this.visitorList,
			categorys: this.dateList,
			isPositive: this.isPositive === 'high',
		};
	}
}

export class PostAverageViewsAdapter {
	value: NBReportRes;
	constructor(obj: NBReportRes) {
		this.value = obj;
	}

	get avgReach() {
		return this.value?.visitor_statistics?.avg_daily_view ?? undefined;
	}

	adapt(): VerticalBarAverageChartProps {
		return {
			desc: (
				<>
					평균 조회 수는{' '}
					<span>{this.avgReach ? round(this.avgReach, 'down') : '-'} 회</span>입니다.
				</>
			),
			barChartValues: [50, 30, 40, 70, 80, 50, 60],
			value: this.avgReach ?? undefined,
			isPositive: true,
		};
	}
}
export class VisitorsAndViewsAdapter {
	value: NBReportRes;
	constructor(obj: NBReportRes) {
		this.value = obj;
	}

	adapt(): VisitorsAndViewsProps {
		return {
			visitors: new VisitorsAdapter(this.value).adapt(),
			averageViews: new PostAverageViewsAdapter(this.value).adapt(),
		};
	}
}
